"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initStateCache = initStateCache;
exports.getCachedState = getCachedState;
exports.setCachedState = setCachedState;
exports.invalidateStateCache = invalidateStateCache;
exports.closeStateCache = closeStateCache;
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
let _root = null;
let _cache = null;
let _watcher = null;
let _rebuildStartedAt = null;
function log(line) {
    process.stderr.write(line + '\n');
}
function initStateCache(root) {
    if (_root === root && _watcher)
        return;
    _root = root;
    _cache = null;
    _watcher?.close();
    const loomDir = path.join(root, 'loom');
    try {
        _watcher = fs.watch(loomDir, { recursive: true }, (eventType, filename) => {
            const hadCache = _cache !== null;
            _cache = null;
            if (hadCache)
                log(`[cache] invalidate path=${filename ?? '?'} reason=${eventType}`);
        });
        _watcher.on('error', (err) => {
            _cache = null;
            log(`[cache] watcher error err=${err.message}`);
        });
    }
    catch {
        // loom dir not yet created — cache stays disabled until next initStateCache call
    }
}
function getCachedState() {
    if (_cache) {
        log('[cache] hit');
        return _cache;
    }
    log('[cache] miss → rebuild start');
    _rebuildStartedAt = Date.now();
    return null;
}
function setCachedState(state) {
    _cache = state;
    if (_rebuildStartedAt !== null) {
        const ms = Date.now() - _rebuildStartedAt;
        log(`[cache] rebuild end durationMs=${ms} weaves=${state.summary.totalWeaves} plans=${state.summary.totalPlans}`);
        _rebuildStartedAt = null;
    }
}
function invalidateStateCache() {
    if (_cache)
        log('[cache] invalidate path=<manual> reason=invalidateStateCache');
    _cache = null;
}
/**
 * Fully tear down the cache + its fs.watch watcher. The long-running `loom mcp`
 * server keeps the watcher for its whole life, but an in-process consumer (the
 * CLI's connectLocalMcp) MUST call this on close — otherwise the recursive
 * fs.watch keeps the Node event loop alive and the CLI process never exits.
 */
function closeStateCache() {
    _watcher?.close();
    _watcher = null;
    _root = null;
    _cache = null;
    _rebuildStartedAt = null;
}
